export enum BusLaneType {
  curbside = 'curbside',
  offset = 'offset',
  center = 'center',
  double = 'double',
}
